import { render } from "./loading_item.vue?vue&type=template&id=012d43c5&scoped=true"
import script from "./loading_item.vue?vue&type=script&lang=js"
export * from "./loading_item.vue?vue&type=script&lang=js"

import "./loading_item.vue?vue&type=style&index=0&id=012d43c5&scoped=true&lang=css"

import exportComponent from "/home/kabull/js/vue/iqtest/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-012d43c5"]])

export default __exports__